import { Navigate, NavLink } from 'react-router-dom'
import useSWR from 'swr'

import FeedbackBanner from '../../components/feedback/FeedbackBanner'
import InvoiceList from '../../components/invoices/list'
import TotalInvoicedBox from '../../components/invoices/TotalInvoicedBox'
import Button, { ButtonSize, ButtonVariant } from '../../components/ui/button'
import PageSectionTitle from '../../components/ui/pageSectionTitle'
import Spinner from '../../components/ui/spinner'
import { getInvoicesSummary } from '../../api'
import { useAuth } from '../../context/auth'
import { ReactComponent as PlusIcon} from '../../static/images/plus.svg'

import './styles.scss'

const DashboardPage = () => {
  const { user } = useAuth()
  const { data: summary, isLoading } = useSWR('/api/invoices/summary', getInvoicesSummary)
  const isInitialLoading = isLoading && summary == null
  const hasInvoices = (summary?.invoiceCount ?? 0) > 0

  if(!user.businessDetails || !user.businessDetails.name) {
    return <Navigate to='/invoices/new' />
  }

  return (
    <>
      <div className='dashboard-page'>
        {isInitialLoading && (
          <div className='dashboard-page__loading'>
            <Spinner message='Loading your invoices' />
          </div>
        )}
        {!isInitialLoading && !hasInvoices && (
          <div className='dashboard-page__empty'>
            <Button size={ButtonSize.LARGE} icon={<PlusIcon width={30} height={30} />} variant={ButtonVariant.LIGHT}>
              <NavLink to='/invoices/new'>Create Your First Invoice</NavLink>
            </Button>
          </div>
        )}
        {!isInitialLoading && hasInvoices && (
          <>
            <section className='dashboard-totals' aria-labelledby='totals-heading'>
              <TotalInvoicedBox />
            </section>
            <section className='dashboard-invoices-section' aria-labelledby='invoices-heading'>
              <PageSectionTitle
                id='invoices-heading'
                title='Invoices'
                description='Filter and manage your invoices.'
              />
              <div className='mb-4' />
              <InvoiceList />
            </section>
          </>
        )}
      </div>
      {!isInitialLoading && hasInvoices && <FeedbackBanner />}
    </>
  )
}

export default DashboardPage
